module.exports = __webpack_public_path__ + "static/media/NotoSans-Light.a6bc1330.woff2";